module.exports = __webpack_public_path__ + "img/popup_gyeonggi_healthcare.e5fb75c3.png";